import { useMutation, useQueryClient } from '@tanstack/react-query';
import { outfitService } from 'shared/src/api';
import type { GetRelatedOutfitListResponse } from 'shared/src/api/goodsService/getRelatedOutfits/types';
import { queryKey } from '../../../../../constant/queryKey';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';

export const useBookmarkOutfit = () => {
  const queryClient = useQueryClient();
  const goodsSno = useGoodsSno();

  return useMutation({
    mutationFn: ({
      sno,
      bookmarked,
    }: {
      sno: number;
      bookmarked: boolean;
    }) =>
      bookmarked
        ? outfitService.removeBookmark(sno).then(() => ({
            sno,
            bookmarked: false,
            // 해제 시에는 deeplink 없음 (토스트 미노출)
            deeplink: null as string | null,
          }))
        : outfitService.postBookmark(sno).then(response => ({
            sno,
            bookmarked: true,
            // '저장한 코디' 페이지로 이동하기 위한 deeplink (토스트 CTA용)
            deeplink: response.deeplink,
          })),
    onSuccess: ({ sno, bookmarked }) => {
      queryClient.setQueryData<GetRelatedOutfitListResponse>(
        queryKey.goodsRelatedOutfit(goodsSno),
        oldData => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            item_list: oldData.item_list.map(outfit =>
              outfit.item.sno === sno
                ? {
                    ...outfit,
                    item: {
                      ...outfit.item,
                      bookmark: {
                        count:
                          outfit.item.bookmark.count + (bookmarked ? 1 : -1),
                        bookmarked,
                      },
                    },
                  }
                : outfit,
            ),
          };
        },
      );
    },
  });
};
